<template>
  <picker-field
    :label="label"
    :value="value"
    :is-focus="isFocus"
    :isNeedInput="isNeedInput"
    title="选择设备"
    @onchange="onchange"
    ref="picker"
    @open="onSearch"
  >
    <template v-slot:tbar>
      <search-bar
        @search="onSearch"
        @focus="onFocusChange"
        name="eq_code,eq_name"
        placeholder="输入设备编号、设备名称进行查找"
        ref="searchBar"
      />
    </template>
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="select(item)"
      >
        <div class="weui-cell__bd">
          <p>{{ item.eq_name }}</p>
          <p class="list-item-muted">
            {{ item.eq_kind }} {{ item.eq_state }}
          </p>
        </div>
        <div class="weui-cell__ft">{{ item.eq_code }}</div>
      </div>
    </scroll-list>
  </picker-field>
</template>

<script>
import PickerField from "@/components/field/PickerField.vue";
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import querylist from "@/mixins/querylist.js";

export default {
  components: {
    PickerField,
    SearchBar,
    ScrollList,
  },
  mixins: [querylist],
  props: {
    label: {
      type: String,
      default: "产品名称",
    },
    value: String,
    isNeedInput: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocus: false,
      listUrl: "/api/oa/equipment/list",
      defaultCondition: [
        {
          field: "eq_statuscode",
          operation: "=",
          value: "ENABLE",
        },
        {
          field: "eq_audit_status_code",
          operation: "=",
          value: "AUDITED",
        },
      ],
    };
  },
  methods: {
    select(item) {
      var me = this;
      me.$emit("input", item.eq_name);
      me.$emit("select", item);
      me.$refs.picker.close();
    },
    onchange(value) {
      var me = this;
      me.$emit("onchange", value);
    },
    onFocusChange(focus) {
      this.isFocus = focus;
    },
  },
};
</script>